import PropTypes from 'prop-types';
import CallToActionIcon from '@mui/icons-material/CallToAction';
// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Avatar, Box, Card, CardHeader, Link, List, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import TotalIncomeCard from 'ui-component/cards/Skeleton/TotalIncomeCard';

// assets
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';

import CoinAoneDark200 from '../assets/images/CoinAoneDark200.png';
import CoinSamsungDark200 from '../assets/images/CoinSamsungDark200.png';
import axios from 'axios';
import { useNavigate } from 'react-router';
import ApiLink from 'API';
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import ViewInoicePendingInvoice from 'views/financial/creditInvoice/ViewInoicePendingInvoice';
// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: `linear-gradient(210.04deg, ${theme.palette.warning.dark} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
        borderRadius: '50%',
        top: -30,
        right: -180
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: `linear-gradient(140.9deg, ${theme.palette.warning.dark} -14.02%, rgba(144, 202, 249, 0) 70.50%)`,
        borderRadius: '50%',
        top: -160,
        right: -130
    }
}));

// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

const TotalIncomeLightCard = ({ isLoading, dataCustomer }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [TotalAoneWallte, setTotalAoneWallte] = useState(0);
    const [TotalcreditInvoice, setTotalcreditInvoice] = useState(0);
    const [Data, setData] = useState({});
    const [LoadingWallet, setLoadingWallet] = useState(false);
    const [OpenViewIvoicePending, setOpenViewIvoicePending] = useState(false);
    async function LoadAoneWallet(customerID) {
        if (!customerID) {
            // No customer selected yet — skip the call (was firing /withcredit/undefined → 404)
            setTotalcreditInvoice(0);
            setTotalAoneWallte(0);
            setLoadingWallet(false);
            return;
        }
        try {
            setLoadingWallet(true);
            const response = await axios.get(ApiLink + '/api/aonewallet/withcredit/' + customerID, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            // console.log(response.status);
            if (response.status === 200) {
                if (response.data.data) {
                    const outcome = response.data.data?.aonewallets?.out || 0;
                    const income = response.data.data?.aonewallets?.in || 0;
                    setData(response.data.data);
                    setTotalcreditInvoice(response.data.data?.creditinvoices?.totalCredit || 0);
                    setTotalAoneWallte(income - outcome);
                } else {
                    setTotalcreditInvoice(0);
                    setTotalAoneWallte(0);
                }

                // console.log(response.data.data);
                // settotal(response.data.total);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
            setLoadingWallet(false);
        } catch (error) {
            console.log(error);
            setTotalcreditInvoice(0);
            setTotalAoneWallte(0);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    useEffect(() => {
        LoadAoneWallet(dataCustomer && dataCustomer?.customerID);
        console.log(dataCustomer);
    }, [dataCustomer, isLoading]);
    return (
        <>
            {isLoading || LoadingWallet ? (
                <TotalIncomeCard />
            ) : dataCustomer !== null ? (
                <CardWrapper border={true} content={false}>
                    <Box sx={{ p: 2 }}>
                        <ViewInoicePendingInvoice Open={OpenViewIvoicePending} setOpen={setOpenViewIvoicePending} Customers={Data} />
                        <List sx={{ py: 0 }}>
                            <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                                <ListItemAvatar>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            ...theme.typography.commonAvatar,
                                            ...theme.typography.largeAvatar,
                                            backgroundColor: theme.palette.warning.light,
                                            color: theme.palette.warning.dark
                                        }}
                                    >
                                        <StorefrontTwoToneIcon fontSize="inherit" />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    sx={{
                                        py: 0,
                                        mt: 0.45,
                                        mb: 0.45
                                    }}
                                    primary={<Typography variant="h4">{dataCustomer?.customerName}</Typography>}
                                    secondary={
                                        <Stack>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: theme.palette.grey[500]
                                                }}
                                            >
                                                ID : {dataCustomer?.customerID}
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: theme.palette.grey[500]
                                                }}
                                            >
                                                Contact : {dataCustomer?.contact}
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: theme.palette.grey[500]
                                                }}
                                            >
                                                Tel : {dataCustomer?.mobile}
                                            </Typography>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    fontFamily: 'boonhome-400'
                                                }}
                                            >
                                                {dataCustomer?.villages ? dataCustomer.villages.vill_name : ''},
                                                {dataCustomer?.districts ? dataCustomer.districts.dr_name : ''},
                                                {dataCustomer?.provinces ? dataCustomer.provinces.pr_name : ''}
                                            </Typography>
                                        </Stack>
                                    }
                                />
                            </ListItem>
                        </List>
                        <Box
                            sx={{
                                mt: 1,
                                width: '100%',
                                display: 'grid',
                                gap: 1,
                                // Auto-stack when container can't fit two 200px columns side by side
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))'
                            }}
                        >
                            <Card sx={{ minWidth: 0, width: '100%' }}>
                                <CardHeader
                                    sx={{ p: 1, '& .MuiCardHeader-content': { minWidth: 0, overflow: 'hidden' }, '& .MuiCardHeader-avatar': { mr: 1 } }}
                                    avatar={
                                        <Avatar
                                            alt="Aone Coin"
                                            src={CoinAoneDark200}
                                            sx={{ width: 20, height: 20, background: 'transparent' }}
                                        />
                                    }
                                    title={
                                        <Typography
                                            variant="subtitle2"
                                            noWrap
                                            sx={{ color: '#3035BC', fontWeight: 700, fontSize: { xs: '0.78rem', sm: '0.85rem' } }}
                                        >
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={TotalAoneWallte.toFixed(2)}
                                                prefix="₭"
                                                decimalSeparator="."
                                                displayType="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                            />
                                        </Typography>
                                    }
                                />
                            </Card>
                            {dataCustomer?.credit && (
                                <Card sx={{ minWidth: 0, width: '100%' }}>
                                    <CardHeader
                                        sx={{ p: 1, '& .MuiCardHeader-content': { minWidth: 0, overflow: 'hidden' }, '& .MuiCardHeader-avatar': { mr: 1 } }}
                                        avatar={<CallToActionIcon sx={{ color: '#f57224', fontSize: 20 }} />}
                                        title={
                                            <Stack direction="row" alignItems="baseline" spacing={0.5} sx={{ minWidth: 0, overflow: 'hidden' }}>
                                                <Link
                                                    component="button"
                                                    variant="body2"
                                                    onClick={() => { setOpenViewIvoicePending(true); }}
                                                    sx={{ minWidth: 0, overflow: 'hidden' }}
                                                >
                                                    <Typography
                                                        variant="subtitle2"
                                                        noWrap
                                                        sx={{ color: '#f57224', fontWeight: 700, fontSize: { xs: '0.78rem', sm: '0.85rem' } }}
                                                    >
                                                        <NumberFormat
                                                            thousandsGroupStyle="thousand"
                                                            value={TotalcreditInvoice || 0}
                                                            prefix="₭"
                                                            decimalSeparator="."
                                                            displayType="text"
                                                            thousandSeparator={true}
                                                            allowNegative={true}
                                                        />
                                                    </Typography>
                                                </Link>
                                                <Typography variant="caption" color="gray">/</Typography>
                                                <Typography
                                                    variant="caption"
                                                    noWrap
                                                    sx={{ color: '#000', fontSize: { xs: '0.72rem', sm: '0.78rem' }, textOverflow: 'ellipsis', overflow: 'hidden' }}
                                                >
                                                    <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={dataCustomer?.creditLimit || 0}
                                                        prefix="₭"
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        thousandSeparator={true}
                                                        allowNegative={true}
                                                    />
                                                </Typography>
                                            </Stack>
                                        }
                                    />
                                </Card>
                            )}
                        </Box>
                    </Box>
                </CardWrapper>
            ) : (
                <TotalIncomeCard />
            )}
        </>
    );
};

TotalIncomeLightCard.propTypes = {
    isLoading: PropTypes.bool
};

export default TotalIncomeLightCard;
